export default __webpack_public_path__ + "static/media/statIcon.2e80c3a9.svg";